import { Env } from '../types';

export const getEnv = () => process.env.NODE_ENV || Env.DEV;
export const isTest = () => getEnv() === Env.TEST;
export const isDev = () => getEnv() === Env.DEV;
export const isProd = () => getEnv() === Env.PROD;

export const getVersion = () => import.meta.env.VITE_BUILD_SHA || Env.DEV;
export const getBuildDate = () => import.meta.env.VITE_BUILD_DATE || null;
